import { IParent } from 'app/shared/model/parent.model';
import { IEleve } from './eleve.model';
import { ISCOLARITE } from './scolarite.model';

export interface IFACTURE {
  montant?: number;
  dateEmission?: string;
  statutPaiement?: StatutPaiement;
  statutFacture?: StatutFacture;
  numeroFacture?: string;
  frais?: string;
  parentId?: IParent | null;
  eleve?: IEleve | null;
  scolariteId?: string;
  scolarite?: ISCOLARITE | null;
  eleveId?: string;
  inscriptionId?: string;
  datePaiement?: string;
  moyenPaiement?: MoyenPaiement;
  ecoleId?: string;
  dateDebut?: string;
  annee?: string;
  id?: string;
  moisAnnee?: string;
  page?: number;
  size?: number;
}

export type FactureDetails = {
  factureId: string;
  eleveId: string;
  ecoleId: string;
  scolariteId: string;
  inscriptionId: string;
  montant: number;
  numeroFacture: string;
  eleve: string;
  parent: string;
  scolarite: string;
  classe: string;
  matricule: string;
  telephone: string | null;
  frais: number | null;
  dateEmission: string;
  datePaiement: string | null;
  moyenPaiement: MoyenPaiement | null;
  statutFacture: StatutFacture;
  statutPaiement?: StatutPaiement;
};

export type FactureDashboardData = {
  collectedByKorischool: number;
  collectedByEspece: number;
  totalRemaining: number;
  totalOmPaye: number;
  totalWavePaye: number;
  totalFacturesPayees: number;
  totalFacturesEnAttentes: number;
};

export const defaulValues: Readonly<FactureDashboardData> = {
  collectedByKorischool: 0,
  collectedByEspece: 0,
  totalRemaining: 0,
  totalOmPaye: 0,
  totalWavePaye: 0,
  totalFacturesPayees: 0,
  totalFacturesEnAttentes: 0,
};

export enum StatutFacture {
  CREE = 'CREE',
  EMISE = 'EMISE',
  PAYEE = 'PAYEE',
  EN_ATTENTE = 'EN_ATTENTE',
}

export enum StatutPaiement {
  A_JOUR = 'A_JOUR',
  NON_A_JOUR = 'NON_A_JOUR',
}

export enum MoyenPaiement {
  OM = 'OM',
  WAVE = 'WAVE',
  ESPECE_CHECK = 'ESPECE_CHECK',
}

export type PaymentRequest = {
  factureId: string;
  phoneNumber: string;
  moyenPaiement: MoyenPaiement;
};

export const defaultValue: Readonly<FactureDetails> = {
  montant: 0,
  dateEmission: '',
  statutPaiement: StatutPaiement.NON_A_JOUR,
  statutFacture: StatutFacture.CREE,
  parent: null,
  eleve: null,
  scolarite: null,
  scolariteId: '',
  numeroFacture: '',
  inscriptionId: '',
  frais: 0,
  datePaiement: '',
  moyenPaiement: MoyenPaiement.ESPECE_CHECK,
  ecoleId: '',
  classe: '',
  eleveId: '',
  factureId: '',
  matricule: '',
  telephone: '',
};

export type FactureRow = {
  key: string; // assuming eleveId is a string
  id: string; // assuming factureId is a string
  matricule: string; // can be string, defaults to empty string
  eleve: string; // can be string, defaults to empty string
  parent: string; // can be string, defaults to empty string
  telephone: string; // can be string, defaults to empty string
  classe: string; // can be string, defaults to empty string
  montant: number; // parsed as a float, defaults to 0 if not available
  statutFacture: string; // assuming statutFacture is a string
};
